export default __webpack_public_path__ + "media/shipment/itella-0a5fd3e2.svg";